export default "__VITE_ASSET__9pVaf94Y__"